import SkeletonCell from "@organisms/Table/TableCells/SkeletonCell/SkeletonCell"

import styles from "./TableLoaderRow.module.scss"
import { TableLoaderRowProps } from "./TableLoaderRow.types"

// The virtualized row that stands in for the next page while it loads: one skeleton cell per visible column.
export default function TableLoaderRow(props: TableLoaderRowProps) {
    const { table, height, transform } = props

    return (
        <tr
            className={styles.base}
            style={{
                height: `${height}px`,
                transform: `translateY(${transform}px)`,
                minWidth: table.getTotalSize(),
            }}
            aria-busy={true}
        >
            {table.getVisibleLeafColumns().map((column) => (
                <SkeletonCell
                    key={column.id}
                    variant={column.columnDef.meta?.loadingType ?? "text"}
                    cellWidth={column.getSize()}
                />
            ))}
        </tr>
    )
}
